import React from "react";
import PropTypes from "prop-types";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import styles from "./AllocToPdqGraph.module.css";

const CustomTooltip = ({ active, payload, label, selectedStamping }) => {
  if (active && payload?.length) {
    return (
      <div className={styles.tooltipBox}>
        <div className={styles.tooltipDate}>{label}</div>

        <div className={styles.greenColor}>
          {selectedStamping} : {payload?.[0]?.value?.toLocaleString?.() ?? 0} %
        </div>
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  payload: PropTypes.array,
  selectedStamping: PropTypes.string,
};

CustomTooltip.defaultProps = {
  active: false,
  label: "",
  payload: [],
  selectedStamping: "Source not defined",
};

const formatDate = (date) => {
  const d = new Date(date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  return `${d.getDate()} ${months[d.getMonth()]}`;
};

const NrDestNrApoDropGraph = ({ data, loading, selectedStamping }) => {
  if (loading) {
    return (
      <div className={styles.shimmerWrapper}>
        <div className={styles.shimmerChart}></div>
      </div>
    );
  }

  if (!data?.length) {
    return <div className={styles.centerState}>No Data</div>;
  }

  const chartWidth = data.length > 10 ? `${data.length * 60}px` : "100%";

  return (
    <div className={styles.graphContainer}>
      <div className={styles.horizontalScroll}>
        <div
          className={styles.NrLossChartWrapper}
          style={{ width: chartWidth }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={data}
              margin={{
                top: 10,
                right: 20,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                horizontal={false}
                vertical
              />

              <XAxis
                dataKey="IngestedDate"
                tick={{ fontSize: 12 }}
                tickFormatter={formatDate}
                interval={0}
              />

              <YAxis tick={{ fontSize: 12 }} />

              <Tooltip
                content={
                  <CustomTooltip selectedStamping={selectedStamping} />
                }
              />

              <Line
                type="linear"
                dataKey="stamping percent"
                stroke="#0e5b2b"
                strokeWidth={2}
                dot={{
                  r: 3,
                  fill: "#0e5b2b",
                  stroke: "#0e5b2b",
                }}
                activeDot={{
                  r: 5,
                  fill: "#0e5b2b",
                  stroke: "#0e5b2b",
                }}
                connectNulls
                name={selectedStamping}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

NrDestNrApoDropGraph.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  selectedStamping: PropTypes.string,
};

NrDestNrApoDropGraph.defaultProps = {
  data: [],
  loading: false,
  selectedStamping: "Source not defined",
};

export default NrDestNrApoDropGraph;